import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
import { Post } from '../../compornents/Post';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons'
import { Analytics,Gtag } from '../../compornents/Analytics';
import { BAG_FIRST } from '../../bagFirst';
import { AreaWaitlist } from '../../compornents/AreaWaitlist';

export const RegisterPostcode = () => {
  const navigate = useNavigate();
  const [postcode, setPostcode] = useState("");
  const [isPostcodeError, setIsPostcodeError] = useState(false);

  // モーダル
  const [Modal, openModal, closeModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });


  async function checkPostcode() {
    // console.log(postcode);
    openModal();
    const request_data = {
      'key': 'yt~z7ESU6J~tLB7ppw(CLD8WddX9PNsr6DH',
      'postcode': postcode,
    }
    const response_data = await Post('public', '/auth/check_postcode.php', request_data);
    // 結果
    // console.log(response_data);
    // try {
    if (response_data.result === 1) {
      // 対象エリア内
      Gtag('within_service_area', { postcode: postcode });
      setIsPostcodeError(false);
      // bag-first: エリア確認OK後はメニュー(990円コース)へ。従来フローは電話番号へ直行
      navigate(BAG_FIRST ? '/register/menu' : '/register', { state: { postcode: postcode } });
      // window.location.replace('register');
    } else {
      // 対象エリア外
      Gtag('outside_service_area', { postcode: postcode });
      setIsPostcodeError(true);
    }
    // } catch (e){
    //   console.log(e);
    //   setIsPostcodeError(true);
    // }
    closeModal();
  }

  useEffect(() => {
    Gtag('view_register_postcode');
  }, []);

  return (
    <div>
      <Analytics title="郵便番号確認" />
      <div className="Register m-auto">
        <div className="App-tel">
          <div className="tel-title">{"自宅から\nクリーニングを注文"}</div>
          <div className="App-telno">
            <input type="text" inputMode="numeric" value={postcode} onChange={e => setPostcode(e.target.value)} placeholder="ご自宅の郵便番号を入力" className="form-control" onKeyDown={(event) => setIsPostcodeError(false)} />

            {/* エリア外: 通知希望フォーム＋マンション版送客（共通コンポーネント AreaWaitlist・2026-09-03） */}
            {isPostcodeError ? <AreaWaitlist postcode={postcode} showMansion /> : ''}
          </div>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
          }}>
            {postcode.length >= 7 ? <button className="button-next" onClick={checkPostcode}>{"次へ"}</button> : <button className="button-next-g">{"次へ"}</button>}
          </div>
        </div>
      </div>
      <Modal>
        <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
          <button onClick={closeModal} className="hide">閉じる</button>
          <div >
            <TailSpin stroke="#000" />
          </div>
          <div className="">
            <div className="">
              処理中です
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
